/* global MEDIA_ROOT, __SERVER__ */

import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import { asyncConnect } from 'redux-connect';

import { trackPageVisit } from '../../utils/tracking';
import { fetchEvents } from '../../state/actions';

import Container from '../Container';
import EventListContainer from '../EventList/EventListContainer.react';

import {
  block,
  carouselLink,
  carouselTitle,
  container,
  description,
  grid,
  heading,
  hero,
  image,
  name,
  section,
  title,
} from './styles.module.css';

const getTrendingQuery = () => ({ resultsPerPage: 6, sort: 'trending' });

/**
 * About Us page component.
 */
class AboutUsPage extends PureComponent {
  componentDidMount() {
    trackPageVisit('About Us');
  }

  render() {
    return (
      <div>
        <div className={hero} />
        <Container className={container}>
          <header>
            <h1 className={heading}>{'Meet the Team'}</h1>
            <p className={description}>
              Whether it’s your first 5k or your tenth ironman we want to be the best place to find
              your perfect race. From Olympic gold medal winners to people psyched by pushing their
              kids around a Disney marathon, these races have changed all of our lives. We’re here
              to make sure they change yours too.
            </p>
          </header>
          <div className={grid}>
            <section className={section}>
              <img src={`${MEDIA_ROOT}/images/team/team_alex.jpg`} alt="" className={image} />
              <h2 className={name}>{'Alex Rose'}</h2>
              <h3 className={title}>
                <div className={block}>{'Co-founder and '}</div>
                {'Chief Product Officer'}
              </h3>
              <dl className={description}>
                <dt>{'Loves'}</dt>
                <dd>{'Trail running'}</dd>
                <dd>{'Cycling'}</dd>
                <dd>{'Swimrun'}</dd>
              </dl>
              <dl className={description}>
                <dt>{'Goals'}</dt>
                <dd>{'Race to the Tower, Breca Swimrun Jersey'}</dd>
              </dl>
              <p className={description}>
                A chemical engineering graduate from Cambridge, I’m one of the co-founders and head
                up the product team at Let’s Do This. I love an ultra, and can often be found
                legging it up Scottish mountains. Last year I narrowly avoided drowning on my first
                swimrun and am going back for more!
              </p>
            </section>

            <section className={section}>
              <img src={`${MEDIA_ROOT}/images/team/team_neil.jpg`} alt="" className={image} />
              <h2 className={name}>{'Neil Lock'}</h2>
              <h3 className={title}>
                <div className={block}>{'Co-founder and '}</div>
                {'Chief Technical Officer'}
              </h3>
              <dl className={description}>
                <dt>{'Loves'}</dt>
                <dd>{'Running'}</dd>
                <dd>{'Cycling'}</dd>
              </dl>
              <dl className={description}>
                <dt>{'Goals'}</dt>
                <dd>{'Marathon PB this year'}</dd>
              </dl>
              <p className={description}>
                I lead up all things tech. I used to be Chief Architect at MoneySavingExpert but,
                more importantly, I’m an obsessive runner and never happier than pushing my
                daughter’s buggy around a Disney marathon.
              </p>
            </section>

            <section className={section}>
              <img src={`${MEDIA_ROOT}/images/team/team_sam.jpg`} alt="" className={image} />
              <h2 className={name}>{'Sam Browne'}</h2>
              <h3 className={title}>
                <div className={block}>{'Co-founder and '}</div>
                {'Chief Executive Officer'}
              </h3>
              <dl className={description}>
                <dt>{'Loves'}</dt>
                <dd>{'Trail Running'}</dd>
                <dd>{'Adventure Racing'}</dd>
              </dl>
              <dl className={description}>
                <dt>{'Goals'}</dt>
                <dd>{'Learn to swim'}</dd>
              </dl>
              <p className={description}>
                I do a bit of everything from getting more events on board to telling more athletes
                about LDT! I love races in the wild from ultras to adventure races and I used to be
                a race director at an expedition race series. I’d love to hear any thoughts on the
                site.
              </p>
            </section>

            <section className={section}>
              <img src={`${MEDIA_ROOT}/images/team/team_marc.jpg`} alt="" className={image} />
              <h2 className={name}>{'Marc Hibbins'}</h2>
              <h3 className={title}>{'Senior Developer'}</h3>
              <dl className={description}>
                <dt>{'Loves'}</dt>
                <dd>{'Triathlon'}</dd>
              </dl>
              <dl className={description}>
                <dt>{'Goals'}</dt>
                <dd>{'Going long'}</dd>
              </dl>
              <p className={description}>
                I’ve been competing in triathlon for a number of years over all distances, and
                coding since I was still cycling with stabilisers on. Engineering alumnus of The
                Guardian, now building the future of LDT.
              </p>
            </section>

            <section className={section}>
              <img src={`${MEDIA_ROOT}/images/team/team_olly.jpg`} alt="" className={image} />
              <h2 className={name}>{'Olly Freeman'}</h2>
              <h3 className={title}>{'Senior Developer'}</h3>
              <dl className={description}>
                <dt>{'Loves'}</dt>
                <dd>{'Running'}</dd>
                <dd>{'Triathlon'}</dd>
              </dl>
              <dl className={description}>
                <dt>{'Goals'}</dt>
                <dd>{'Doing enough exercise so I can eat all the donuts'}</dd>
              </dl>
              <p className={description}>
                After a career as a pro triathlete followed by a degree in Computer Science and a
                year working in Silicon Valley as a software engineer, my job is now ensuring that
                the LDT website runs as smoothly as possible.
              </p>
            </section>

            <section className={section}>
              <img src={`${MEDIA_ROOT}/images/team/team_stan.jpg`} alt="" className={image} />
              <h2 className={name}>{'Constantine Louloudis'}</h2>
              <h3 className={title}>{'Head of Sales'}</h3>
              <dl className={description}>
                <dt>{'Loves'}</dt>
                <dd>{'Cycling'}</dd>
                <dd>{'Running'}</dd>
                <dd>{'Rowing'}</dd>
              </dl>
              <dl className={description}>
                <dt>{'Goals'}</dt>
                <dd>{'Marathon PB & UTMB qualification'}</dd>
              </dl>
              <p className={description}>
                I’m a 2-time Olympic medalist, having won an Olympic Gold Medal rowing in the men’s
                four in Rio 2016 for Team GB. I was recruited to LDT from Goldman Sachs and now I
                run the sales team, in between marathons!
              </p>
            </section>

            <section className={section}>
              <img src={`${MEDIA_ROOT}/images/team/team_john.jpg`} alt="" className={image} />
              <h2 className={name}>{'John Kent'}</h2>
              <h3 className={title}>{'Key Account Manager'}</h3>
              <dl className={description}>
                <dt>{'Loves'}</dt>
                <dd>{'Running'}</dd>
                <dd>{'Circuits'}</dd>
              </dl>
              <dl className={description}>
                <dt>{'Goals'}</dt>
                <dd>{'Get a PB at the Rio marathon in 2018'}</dd>
              </dl>
              <p className={description}>
                Before joining LDT, I was a professional polo player, as well as commentator and MC
                for sporting events around the world. I love running, so you’ll most likely find me
                at the start line of most of our partner events just loving life.
              </p>
            </section>

            <section className={section}>
              <img src={`${MEDIA_ROOT}/images/team/team_ari.jpg`} alt="" className={image} />
              <h2 className={name}>{'Ariana Murray Wells'}</h2>
              <h3 className={title}>{'Product Designer'}</h3>
              <dl className={description}>
                <dt>{'Loves'}</dt>
                <dd>{'Running'}</dd>
                <dd>{'Skiing'}</dd>
                <dd>{'Cycling'}</dd>
              </dl>
              <dl className={description}>
                <dt>{'Goals'}</dt>
                <dd>{'My first triathlon & the Havana marathon in 2018'}</dd>
              </dl>
              <p className={description}>
                Before LDT I was freelance for 3 years, designing for Imperial College, Averon &
                Caprice Holdings among others. Having run the London and Sierra Leone marathons, I’m
                attempting a marathon abroad every year — big talk!
              </p>
            </section>

            <section className={section}>
              <img src={`${MEDIA_ROOT}/images/team/team_hannah.jpg`} alt="" className={image} />
              <h2 className={name}>{'Want to join the team?'}</h2>
              <h3 className={title}>{'We want to meet you'}</h3>
              <p className={description}>
                We’re the fastest growing sports startup in London and are always looking for new
                people to join our fast-moving team.
                <br />
                <br />
                Get in touch <a href="mailto:info@letsdothis.com">{'info@letsdothis.com'}</a>.
              </p>
            </section>
          </div>

          <div>
            <Link to="/s?sort=trending" rel="nofollow" className={carouselLink}>
              See all
            </Link>
            <h3 className={carouselTitle}>Our favourite events</h3>
            <EventListContainer
              query={getTrendingQuery()}
              showLoadMore={false}
              source="about_page"
              carousel
            />
          </div>
        </Container>
      </div>
    );
  }
}

export const asyncPromises = [{
  promise: ({ store: { dispatch } }) =>
    (__SERVER__ ? dispatch(fetchEvents(getTrendingQuery())) : Promise.resolve()),
}];

// Wrap in [redux-connect](https://github.com/makeomatic/redux-connect)
const AboutUsPageWithAsync = asyncConnect(asyncPromises)(AboutUsPage);

export default AboutUsPageWithAsync;



// WEBPACK FOOTER //
// ./app/src/components/AboutUsPage/index.jsx